import { render } from "./FilterProduct.vue?vue&type=template&id=157d5adc&scoped=true"
const script = {}

import "./FilterProduct.vue?vue&type=style&index=0&id=157d5adc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157d5adc"]])

export default __exports__